import authorize from './pages/authorize'
// import user from './pages/user'
import studentuser from './pages/student_user'
import register from './pages/register'

const pageRouters = [
  authorize,
  // user,
  studentuser,
  register
]

export default pageRouters



// WEBPACK FOOTER //
// ./src/router/pageRouters.js